import React, { useState } from "react";
import FacultyName from "../../component/facultyName";
import HeroSlider from "../../../../component/HeroSlider";
import DeansMessage from "../../component/deansMessage";
import FacultyMembers from "../../component/facultyMembers";
import Footer from "../../../../component/Footer";
import { VscAdd } from "react-icons/vsc";
import { VscChromeClose } from "react-icons/vsc";
import PhotoAlbum from "../../../../component/PhotoAlbum";
import InternationalCollaboration from "../../../../component/InternationalCollaboration";

import { facultyImgEngineering } from "../../../../static";

import { LeftSideNavigationCivil } from "../../component/leftSideNavigationCivil";
import { departmentCode, employeeType } from "../../../../util";
import NewsNoticeForDepartmentAndFaculty from "../../component/NewsNoticeForDepartmentAndFaculty";

const DepartmentOfCivil = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const config = {
    department: departmentCode.civil,
    full: employeeType.full,
    contractual: employeeType.contractual,
  };
  const programLinks = [
    {
      link: "/bscinCivil",
      title: "BSc in Civil",
    },
  ];

  return (
    <div>
      <FacultyName
        name="Department of Civil Engineering"
        facultyImg={facultyImgEngineering}
      />
      <div className="facultySliderandHeader">
        <LeftSideNavigationCivil />
        <div className="facultySlider">
          <HeroSlider config={config} />
        </div>
      </div>
      {/* Mobile Responsive Start*/}
      <div
        id="mobileMenuButton"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
      >
        <button>
          <VscAdd className="moreMenu" />
        </button>
      </div>
      {mobileMenuOpen && (
        <div id="mobileMenuContent">
          <button
            id="closeButton"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <VscChromeClose className="closeButtonIcon" />
          </button>
          <LeftSideNavigationCivil />
        </div>
      )}
      {/* Mobile Responsive End*/}
      <DeansMessage
        department={config.department}
        program={programLinks}
        messageFrom="Chairperson"
      />

      {/* <div className="facultyContent mt-5">
        <div className="DeptRightSideNewsAndEvents">

          <News />
          <NoticeAndEventsRapper depID="6" deptNoticeUrl="noticesCSE" />


        </div>
      </div> */}

      <NewsNoticeForDepartmentAndFaculty config={config} />
      <FacultyMembers config={config} />
      {/* <DeptTestimonials depName="Department of CSE" /> */}
      <PhotoAlbum />
      <InternationalCollaboration />
      <Footer />
    </div>
  );
};

export default DepartmentOfCivil;
